import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const _0e433b93 = () => import('../pages/about.vue' /* webpackChunkName: "pages/about" */).then(m => m.default || m)
const _95b46dfe = () => import('../pages/cooperation.vue' /* webpackChunkName: "pages/cooperation" */).then(m => m.default || m)
const _7b2a4566 = () => import('../pages/demo.vue' /* webpackChunkName: "pages/demo" */).then(m => m.default || m)
const _e9039c6a = () => import('../pages/services/index.vue' /* webpackChunkName: "pages/services/index" */).then(m => m.default || m)
const _155a2dd2 = () => import('../pages/trait/index.vue' /* webpackChunkName: "pages/trait/index" */).then(m => m.default || m)
const _677a0578 = () => import('../pages/uphold.vue' /* webpackChunkName: "pages/uphold" */).then(m => m.default || m)
const _9d845aee = () => import('../pages/services/application.vue' /* webpackChunkName: "pages/services/application" */).then(m => m.default || m)
const _6b678917 = () => import('../pages/services/crm.vue' /* webpackChunkName: "pages/services/crm" */).then(m => m.default || m)
const _01e68cc5 = () => import('../pages/services/fms.vue' /* webpackChunkName: "pages/services/fms" */).then(m => m.default || m)
const _73e6b15c = () => import('../pages/services/hrm.vue' /* webpackChunkName: "pages/services/hrm" */).then(m => m.default || m)
const _37409e12 = () => import('../pages/services/index2.vue' /* webpackChunkName: "pages/services/index2" */).then(m => m.default || m)
const _3979709f = () => import('../pages/services/marketing.vue' /* webpackChunkName: "pages/services/marketing" */).then(m => m.default || m)
const _697a9ba9 = () => import('../pages/services/oa.vue' /* webpackChunkName: "pages/services/oa" */).then(m => m.default || m)
const _7589230d = () => import('../pages/services/shop.vue' /* webpackChunkName: "pages/services/shop" */).then(m => m.default || m)
const _76f0f812 = () => import('../pages/services/small-routine.vue' /* webpackChunkName: "pages/services/small-routine" */).then(m => m.default || m)
const _33046b5a = () => import('../pages/services/tms.vue' /* webpackChunkName: "pages/services/tms" */).then(m => m.default || m)
const _f59f07d4 = () => import('../pages/services/wms.vue' /* webpackChunkName: "pages/services/wms" */).then(m => m.default || m)
const _44e4d3b6 = () => import('../pages/trait/contact.vue' /* webpackChunkName: "pages/trait/contact" */).then(m => m.default || m)
const _7470b68f = () => import('../pages/trait/help/index.vue' /* webpackChunkName: "pages/trait/help/index" */).then(m => m.default || m)
const _7536168a = () => import('../pages/trait/help/search.vue' /* webpackChunkName: "pages/trait/help/search" */).then(m => m.default || m)
const _06bd32e2 = () => import('../pages/trait/help/detail/_id.vue' /* webpackChunkName: "pages/trait/help/detail/_id" */).then(m => m.default || m)
const _7aedde92 = () => import('../pages/trait/help/_id.vue' /* webpackChunkName: "pages/trait/help/_id" */).then(m => m.default || m)
const _2dfb1658 = () => import('../pages/index.vue' /* webpackChunkName: "pages/index" */).then(m => m.default || m)
const _34bc4d56 = () => import('../pages/-404.vue' /* webpackChunkName: "" */).then(m => m.default || m)



if (process.client) {
  window.history.scrollRestoration = 'manual'
}
const scrollBehavior = function (to, from, savedPosition) {
  // if the returned position is falsy or an empty object,
  // will retain current scroll position.
  let position = false

  // if no children detected
  if (to.matched.length < 2) {
    // scroll to the top of the page
    position = { x: 0, y: 0 }
  } else if (to.matched.some((r) => r.components.default.options.scrollToTop)) {
    // if one of the children has scrollToTop option set to true
    position = { x: 0, y: 0 }
  }

  // savedPosition is only available for popstate navigations (back button)
  if (savedPosition) {
    position = savedPosition
  }

  return new Promise(resolve => {
    // wait for the out transition to complete (if necessary)
    window.$nuxt.$once('triggerScroll', () => {
      // coords will be used if no selector is provided,
      // or if the selector didn't match any element.
      if (to.hash) {
        let hash = to.hash
        // CSS.escape() is not supported with IE and Edge.
        if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
          hash = '#' + window.CSS.escape(hash.substr(1))
        }
        try {
          if (document.querySelector(hash)) {
            // scroll to anchor by returning the selector
            position = { selector: hash }
          }
        } catch (e) {
          console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).')
        }
      }
      resolve(position)
    })
  })
}


export function createRouter () {
  return new Router({
    mode: 'history',
    base: '/',
    linkActiveClass: 'nuxt-link-active',
    linkExactActiveClass: 'nuxt-link-exact-active',
    scrollBehavior,
    routes: [
		{
			path: "/about",
			component: _0e433b93,
			name: "about"
		},
		{
			path: "/cooperation",
			component: _95b46dfe,
			name: "cooperation"
		},
		{
			path: "/demo",
			component: _7b2a4566,
			name: "demo"
		},
		{
			path: "/services",
			component: _e9039c6a,
			name: "services"
		},
		{
			path: "/trait",
			component: _155a2dd2,
			name: "trait"
		},
		{
			path: "/uphold",
			component: _677a0578,
			name: "uphold"
		},
		{
			path: "/services/application",
			component: _9d845aee,
			name: "services-application"
		},
		{
			path: "/services/crm",
			component: _6b678917,
			name: "services-crm"
		},
		{
			path: "/services/fms",
			component: _01e68cc5,
			name: "services-fms"
		},
		{
			path: "/services/hrm",
			component: _73e6b15c,
			name: "services-hrm"
		},
		{
			path: "/services/index2",
			component: _37409e12,
			name: "services-index2"
		},
		{
			path: "/services/marketing",
			component: _3979709f,
			name: "services-marketing"
		},
		{
			path: "/services/oa",
			component: _697a9ba9,
			name: "services-oa"
		},
		{
			path: "/services/shop",
			component: _7589230d,
			name: "services-shop"
		},
		{
			path: "/services/small-routine",
			component: _76f0f812,
			name: "services-small-routine"
		},
		{
			path: "/services/tms",
			component: _33046b5a,
			name: "services-tms"
		},
		{
			path: "/services/wms",
			component: _f59f07d4,
			name: "services-wms"
		},
		{
			path: "/trait/contact",
			component: _44e4d3b6,
			name: "trait-contact"
		},
		{
			path: "/trait/help",
			component: _7470b68f,
			name: "trait-help"
		},
		{
			path: "/trait/help/search",
			component: _7536168a,
			name: "trait-help-search"
		},
		{
			path: "/trait/help/detail/:id?",
			component: _06bd32e2,
			name: "trait-help-detail-id"
		},
		{
			path: "/trait/help/:id",
			component: _7aedde92,
			name: "trait-help-id"
		},
		{
			path: "/",
			component: _2dfb1658,
			name: "index"
		},
		{
			path: "*",
			component: _34bc4d56,
			name: "404"
		}
    ],
    
    
    fallback: false
  })
}



// WEBPACK FOOTER //
// ./.nuxt/router.js